import { db, auth, fb, func } from '@/main'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    profile: {},
    lang: '',
    steps: ['login', 'verify', 'wait'],
    current: 'login',
    error: null,
    loading: false,
    role: 'visitor',
    tenantId: '',
    branchId: '',
    customUid: ''
  },
  mutations: {
    nextStep(state) {
      const nextIndex = state.steps.findIndex((x) => x === state.current) + 1
      state.current = state.steps[nextIndex]
    },
    setCurrentToWait(state) {
      state.current = state.steps[2]
    },
    loading(state, payload) {
      state.loading = payload
    },
    error(state, payload) {
      state.error = payload
    },
    startAction(state) {
      state.error = null
      state.loading = true
    },
    stopAction(state) {
      state.loading = false
    },
    profile(state, payload) {
      state.lang = payload.lang
      state.profile = payload
    },
    setClaim(state, payload) {
      state.role = payload.role
      state.tenantId = payload.tenantId
      state.branchId = payload.branchId
      console.log('claim data', state.role, state.tenantId, state.branchId)
    }
  },
  actions: {
    /**
     * @func
     * @desc this will get the current login user's data and its setting
     *   it will also subscribe in case for is there any changes
     * @param [context]
     * @return {Promise<unknown>}
     */
    subscribeProfile(context) {
      db.collection('users')
        .doc(auth.currentUser.uid)
        .onSnapshot((snapshot) => {
          // no matter what, we only get one doc
          if (!snapshot) {
            const error = new Error('User does not exist')
            context.commit('error', error)
          }
          context.commit('profile', snapshot.data() || {})
        })
    },
    logout(context) {
      auth
        .signOut()
        .then(() => {
          // success and let's reload it
          window.location.reload()
        })
        .catch((error) => {
          context.commit('error', error)
        })
    },
    linkFacebook() {
      return new Promise((resolve, reject) => {
        const currentUser = auth.currentUser
        const facebookProvider = new fb.auth.FacebookAuthProvider()
        const providerId = 'facebook.com'
        facebookProvider.addScope('pages_messaging')
        facebookProvider.addScope('pages_manage_metadata')
        if (
          currentUser.providerData &&
          currentUser.providerData.findIndex(
            (x) => x.providerId === providerId
          ) > -1
        ) {
          // unlink first
          auth.currentUser
            .unlink(providerId)
            .then(() => {
              auth.currentUser
                .linkWithPopup(facebookProvider)
                .then((result) => {
                  return resolve(result)
                })
                .catch((error) => {
                  return reject(error)
                })
            })
            .catch((error) => reject(error))
        } else {
          auth.currentUser
            .linkWithPopup(facebookProvider)
            .then((result) => {
              return resolve(result)
            })
            .catch((error) => {
              return reject(error)
            })
        }
      })
    },

    listFacebookPages(context, fbLoginResult) {
      return new Promise((resolve, reject) => {
        const profile = fbLoginResult.additionalUserInfo.profile
        const facebookUid = profile.id
        const accessToken = fbLoginResult.credential.accessToken
        axios
          .get(
            `https://graph.facebook.com/${facebookUid}/accounts?fields=name,access_token&access_token=${accessToken}`
          )
          .then((result) => resolve(result.data))
          .catch((error) => reject(error))
      })
    },

    subscribeFacebookPageToChatbot(context, payload) {
      return new Promise((resolve, reject) => {
        const body = {
          shortLivedUserAccessToken: payload.shortLivedUserAccessToken,
          fbUserId: payload.fbUserId,
          pageId: payload.pageId
        }
        const callLinkChatbotToFacebook = func.httpsCallable(
          'callLinkChatbotToFacebook'
        )
        callLinkChatbotToFacebook(body)
          .then((res) => resolve(res))
          .catch((err) => reject(err))
      })
    }

    // TODO: Profile Update
    // updateProfile (context, payload) {
    //   db.collection('users')
    //     .doc(auth.currentUser.uid)
    //     .update({
    //       name: payload
    //     })
    //     .then(() => {
    //       console.log('update successful')
    //     })
    //     .catch(error => {
    //       console.log('error', error)
    //     })
    // }
  },
  getters: {
    /**
     * @func
     * @desc return an appropriate locales like [en, km, ja ...]
     *   this will return user's chosen language if exists
     *   or it will read from browser's setting
     *   if all fails, it will give default 'en'
     * @param [state]
     * @return {string}
     */
    lang: function (state) {
      if (state.lang) {
        return state.lang
      } else {
        let returningLang = ''
        if (navigator.languages !== undefined) {
          returningLang = navigator.languages[0]
        } else {
          returningLang = navigator.language
        }
        if (returningLang) {
          if (returningLang.includes('-')) {
            returningLang = returningLang.split('-')[0]
          }
          return returningLang
        } else return 'en'
      }
    },
    name: function (state) {
      return state.profile.name || ''
    },
    isOwner: function (state) {
      return auth.currentUser && state.role === 'owner'
    },
    isAdmin: function (state) {
      return (
        auth.currentUser && (state.role === 'owner' || state.role === 'admin')
      )
    },
    isSeller: function (state) {
      const allowable = ['owner', 'admin', 'seller']
      return auth.currentUser && allowable.includes(state.role)
    },
    isAnalyst: function (state) {
      const allowable = ['owner', 'admin', 'analyst']
      return auth.currentUser && allowable.includes(state.role)
    },
    isLogin: function (state) {
      console.log('Current role', state.role)
      return auth.currentUser || false
    },
    currentUid: function () {
      return auth.currentUser ? auth.currentUser.uid : null
    }
  }
}
